
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface QuestionSet {
    Question_Set_Name: string;
}

interface TokenResponse {
    token: string;
  }

@Injectable()
export class CloneService {
    constructor(private http: HttpClient) {}
    

    public clone_set_details(set: QuestionSet): Observable<any> {
        // console.log("set in service",set)
        const base = this.http.post('/users/view_questionset/set_details', set);
        const request = base.pipe(
          map((data: TokenResponse) => {
           
            return data;
          })
        );
        
        return request;
      }

      // public get_set_config_details(set: QuestionSet): Observable<any> {
      //   console.log("set in service",set)
      //   const base = this.http.post('/users/clone/cloneqnsetconfig_details', set);
      //   const request = base.pipe(
      //     map((data: TokenResponse) => {
      //       console.log("data**",data)
      //       return data;
      //     })
      //   );
      //   return request;
      // }
    

}